import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import "../styles/roadmap.css"
import api from '../pages/api';
import React, { useEffect, useState } from 'react';


function Roadmap() {
    const [activeLevels, setActiveLevels] = useState([]);
    const [phone, setPhone] = useState();
    useEffect(() => {
        api.get('student/api/v1/show-student-profile/')
            .then((res) => {

                const phoneNumber = res.data.phone_number;
                setPhone(phoneNumber);

            })
            .catch((err) => {
                console.error('خطا در گرفتن اطلاعات پروفایل:', err);
            });
    }, []);
    useEffect(() => {
        const fetchLevels = async () => {
            try {

                const response = await api.get(`/manager/api/v1/${phone}/courses/by-level2/`);
                const activeIds = response.data.map(item => item.course_level);
                setActiveLevels(activeIds);

            } catch (error) {
                console.error("خطا در دریافت اطلاعات مسیر:", error);
            }
        };
        fetchLevels();
    }, [phone]);

    const getStatusColor = (levelId, originalColor) => {
        const gray = "#d1d5db";
        return activeLevels.includes(levelId) ? originalColor : gray;
    };
    const getStepStyle = (color, stepId) => {
        const finalColor = activeLevels.includes(stepId) ? color : "rgba(209, 213, 219, 1)";

        return {
            backgroundColor: finalColor,
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "13px",
            fontWeight: "bold",
            padding: "0 25px",
            marginRight: "-12px", // ایجاد همپوشانی
            clipPath: "polygon(92% 0%, 100% 50%, 92% 100%, 0% 100%, 8% 50%, 0% 0%)",
            flex: 1,
            minWidth: "180px"
        }

    };


    return (
        <Tabs
            defaultActiveKey="مسیر پایتون"
            id="uncontrolled-tab-example"
            className="my-3  roadmap-tab"
        >
            <Tab eventKey="مسیر قبل از پایتون" title="مسیر قبل از پایتون">
                <div className='d-lg-flex d-none' style={{
                    display: "flex",
                    flexDirection: "column-reverse", // ردیف‌ها را از پایین به بالا می‌چیند
                    alignItems: "center",
                    gap: "40px",
                    padding: "100px",
                    paddingTop: "20px",
                }}>

                    {/* ردیف ۱: شروع مسیر (پایین) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "800px", marginTop: "-20px" }}>
                        <div style={{
                            width: "90px", height: "90px", backgroundColor: "#f5b740", borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center", color: "white",
                            border: "4px solid white", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", zIndex: 5, marginRight: "-20px"
                        }}>
                            شروع مسیر
                        </div>

                        <div style={{ ...getStepStyle("#f5b740", 1), clipPath: "polygon(0% 50%, 8% 0%, 100% 0%, 100% 100%, 8% 100%)" }}>اسکرچ جونیور (ترم اول)</div>
                        <div style={{ ...getStepStyle("#f5b740", 2), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)" }}>اسکرچ جونیور (ترم دوم)</div>
                        <div style={{ ...getStepStyle("#f5b740", 3), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)" }}>اسکرچ جونیور (ترم سوم)</div>

                        {/* دایره شروع */}

                        {/* زانوی اول (سمت چپ) */}
                        <div style={{

                            position: "absolute", left: "-70px", top: "-70px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(3, "#f39233"),
                            borderLeftColor: getStatusColor(3, "#f39233"),
                        }}></div> <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(7, "#e3656d"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "2px", top: "-160px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(3, "#f39233"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "-180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>

                    {/* ردیف ۲: میانی (نارنجی) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "800px" }}>
                        <div style={{ ...getStepStyle("#f39233", 6), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)" }}>اسکرچ (ترم سوم)</div>
                        <div style={getStepStyle("#f39233", 5)}>اسکرچ (ترم دوم)</div>
                        <div style={{ ...getStepStyle("#f39233", 4), marginLeft: "8px", clipPath: "polygon(92% 0%, 100% 50%, 92% 100%, 0% 100%, 8% 50%, 0% 0%)" }}>اسکرچ (ترم اول)</div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{

                            position: "absolute", right: "-81px", top: "-90px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%",
                            borderTopColor: getStatusColor(7, "#e3656d"),
                            borderRightColor: getStatusColor(7, "#e3656d"),
                            borderLeftColor: "transparent", borderBottomColor: "transparent",

                        }}></div>
                    </div>

                    {/* ردیف ۳: نهایی (قرمز) */}
                    <div style={{ display: "flex", alignItems: "center", width: "800px", position: "relative" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("#e3656d", 7),
                            flex: 1,
                            marginRight: "-5px",
                            clipPath: "polygon(100% 0%, 97% 50%, 100% 100%, 0% 100%, 0% 50%, 0% 0%)"
                        }}>
                            ماجراجویی‌های من و رایانا (هوش مصنوعی مولد برای کودکان)
                        </div>
                        <div style={{ display: "flex", gap: "4px", marginLeft: "10px" }}>
                            <div style={{
                                width: "48px",
                                height: "50px",
                                marginRight: "-25px",
                                backgroundColor: getStatusColor(7, "#e3656d"),
                                zIndex: "10",
                                clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"
                            }}></div>
                            {["rgba(241, 129, 138, 1)", "rgba(254, 159, 166, 1)", "rgba(239, 182, 186, 1)", "rgba(248, 212, 215, 1)"].map((op, i, arr) => (
                                <div
                                    key={i}
                                    style={{
                                        width: "20px",
                                        height: "50px",
                                        backgroundColor: op,
                                        clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                        marginRight: "-13px",
                                        // zIndex را به ترتیب معکوس قرار می‌دهیم
                                        zIndex: arr.length - i,
                                        position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                                    }}
                                ></div>
                            ))}
                        </div>
                    </div>

                </div>
                <div className='d-flex d-lg-none' style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "40px",

                    padding: "40px 20px",
                }}>

                    {/* ردیف ۱: شروع مسیر (پایین) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px", marginTop: "-20px", height: "50px" }}>
                        <div style={{
                            width: "90px", height: "90px", backgroundColor: "#f5b740", borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center", color: "white",
                            border: "4px solid white", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", zIndex: 5, marginRight: "-20px"
                        }}>
                            شروع مسیر
                        </div>

                        <div style={{ ...getStepStyle("#f5b740", 1), clipPath: "none", gap: "20px" }}>اسکرچ جونیور(ترم اول) </div>


                        {/* زانوی اول (سمت چپ) */}

                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(1, "#f5b740"),
                            borderLeftColor: getStatusColor(1, "#f5b740"),
                        }}></div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(1, "#f5b740"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>


                    </div>

                    {/* ردیف ۲: میانی (نارنجی) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("#f5b740", 2), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}>اسکرچ جونیور(ترم دوم)</div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(2, "#f5b740"),
                            borderRightColor: getStatusColor(2, "#f5b740"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(2, "#f5b740"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>

                    {/* ردیف ۳: نهایی (قرمز) */}
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("#f5b740", 3),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            اسکرچ جونیور(ترم سوم)
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(3, "#f5b740"),
                            borderLeftColor: getStatusColor(3, "#f5b740"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(3, "#f5b740"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(240, 139, 45, 1)", 4), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}>اسکرچ (ترم اول)</div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(2, "rgba(240, 139, 45, 1)"),
                            borderRightColor: getStatusColor(2, "rgba(240, 139, 45, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(2, "rgba(240, 139, 45, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(240, 139, 45, 1)", 5),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            اسکرچ (ترم دوم)
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(5, "rgba(240, 139, 45, 1)"),
                            borderLeftColor: getStatusColor(5, "rgba(240, 139, 45, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(5, "rgba(240, 139, 45, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(240, 139, 45, 1)", 6), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}>اسکرچ (ترم سوم)</div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(6, "rgba(240, 139, 45, 1)"),
                            borderRightColor: getStatusColor(6, "rgba(240, 139, 45, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(6, "rgba(240, 139, 45, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "260px", position: "relative", marginRight: "60px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(224, 99, 109, 1)", 7),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)",
                            zIndex: "20",
                            padding: "0"

                        }}>
                            ماجراجوهایی من و رایانا
                            <br />
                            (هوش مصنوعی مولد برای کودکان)
                        </div>
                        <div style={{ display: "flex", gap: "4px", marginLeft: "10px" }}>
                            <div style={{
                                width: "28px",
                                height: "50px",
                                marginRight: "-25px",
                                backgroundColor: "transparent",
                                zIndex: "10",
                                clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"
                            }}></div>
                            {["rgba(241, 129, 138, 1)", "rgba(254, 159, 166, 1)", "rgba(239, 182, 186, 1)", "rgba(248, 212, 215, 1)"].map((op, i, arr) => (
                                <div
                                    key={i}
                                    style={{
                                        width: "20px",
                                        height: "50px",
                                        backgroundColor: op,
                                        clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                        marginRight: "-13px",
                                        // zIndex را به ترتیب معکوس قرار می‌دهیم
                                        zIndex: arr.length - i,
                                        position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                                    }}
                                ></div>
                            ))}
                        </div>

                    </div>

                </div>

            </Tab>
            <Tab eventKey="مسیر پایتون" title="مسیر پایتون">
                <div className='d-lg-flex d-none' style={{ padding: "100px", paddingTop: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "40px" }}>

                    {/* ردیف اول: از راست به چپ (آبی) */}
                    <div style={{ display: "flex", flexDirection: "row-reverse", alignItems: "center", width: "800px", position: "relative" }}>

                        <div style={{ ...getStepStyle("rgba(249, 193, 30, 1)", 11), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)" }}> بازی سازی با پایتون</div>
                        <div style={{ ...getStepStyle("#4ca6d8", 10), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)", }}> دوره متوسطه پایتون</div>
                        <div style={{ ...getStepStyle("#4ca6d8", 9), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)", }} > پایتون مقدماتی دو</div>
                        <div style={{ ...getStepStyle("#4ca6d8", 8), clipPath: "polygon(100% 0%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)", marginRight: "-18px" }}> پایتون مقدماتی یک</div>
                        <div style={{ display: "flex", marginRight: "-10px" }}>
                            {["rgba(114, 194, 234, 1)", "rgba(148, 209, 239, 1)", "rgba(191, 224, 240, 1)", "rgba(220, 235, 243, 1)", "rgba(241, 250, 255, 1)"].map((c, i, arr) => (
                                <div key={i} style={{
                                    width: "20px", height: "50px", backgroundColor: c,
                                    clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                    marginRight: "-8px", zIndex: arr.length - i, position: "relative"
                                }} />
                            ))}
                        </div>

                        <div style={{

                            position: "absolute", left: "-50px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(11, "rgb(249, 193, 30)"),
                            borderLeftColor: getStatusColor(11, "rgb(249, 193, 30)"),
                        }}></div>
                    </div>

                    {/* ردیف دوم: از چپ به راست (نارنجی/سرمه‌ای) */}
                    <div style={{ direction: "ltr", display: "flex", alignItems: "center", width: "800px", position: "relative", paddingLeft: "18px" }}>
                        <div style={{ ...getStepStyle("rgba(159, 208, 107, 1)", 12), clipPath: "polygon(92% 0%, 100% 50%, 92% 100%, 0% 100%, 10% 50%, 0% 0%)", marginLeft: "7px" }}>  بازی سازی با میکرو پایتون</div>
                        <div style={{ ...getStepStyle("rgb(224, 99, 109)", 13), clipPath: "polygon(92% 0%, 100% 50%, 92% 100%, 0% 100%, 8% 50%, 0% 0%)" }} >پایتون و اپلیکیشن سازی </div>
                        <div style={getStepStyle("#1a237e", 14)}>علم داده</div>
                        <div style={{ ...getStepStyle("#3482c3", 15), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)" }}>هوش مصنوعی یک</div>

                        <div style={{

                            position: "absolute", right: "-81px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(15, "#3482c3"),
                            borderRightColor: getStatusColor(15, "#3482c3"),
                        }}></div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(15, "#3482c3"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "2px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(11, "rgba(249, 193, 30, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "1px",
                                position: "absolute",
                                left: "20px",


                            }}
                        ></div>
                    </div>

                    {/* ردیف سوم: دوباره از راست به چپ (آبی/سبز) */}
                    <div style={{ direction: "ltr", display: "flex", flexDirection: "row-reverse", alignItems: "center", width: "800px", position: "relative" }}>
                        <div style={{ ...getStepStyle("#3482c3", 16), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)", marginRight: "-3px" }}>هوش مصنوعی دو</div>
                        <div style={{ ...getStepStyle("#3482c3", 17), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)" }}>هوش مصنوعی سه</div>

                        <div style={{ ...getStepStyle("#90d069", 19), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)" }}>اینترنت اشیا</div>

                        {/* فلش‌های انتهایی (سمت چپ) */}
                        <div style={{ display: "flex", marginRight: "10px" }}>
                            {["#d8f0c1", "#b5e399", "#90d069", "#76b852"].map((c, i, arr) => (
                                <div key={i} style={{
                                    width: "20px", height: "50px", backgroundColor: c,
                                    clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                    marginRight: "-8px", zIndex: arr.length + i, position: "relative"
                                }} />
                            ))}
                        </div>
                    </div>
                </div>
                <div className='d-flex d-lg-none' style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "40px",

                    padding: "40px 20px",
                }}>

                    {/* ردیف ۱: شروع مسیر (پایین) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px", marginTop: "-20px", height: "50px" }}>
                        <div style={{ display: "flex", gap: "4px", marginLeft: "10px" }}>
                            <div style={{
                                width: "28px",
                                height: "50px",
                                marginRight: "-25px",
                                backgroundColor: "transparent",
                                zIndex: "10",
                                clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"
                            }}></div>
                            {["rgba(114, 194, 234, 1)", "rgba(148, 209, 239, 1)", "rgba(191, 224, 240, 1)", "rgba(220, 235, 243, 1)"].map((op, i, arr) => (
                                <div
                                    key={i}
                                    style={{
                                        width: "20px",
                                        height: "50px",
                                        backgroundColor: op,
                                        clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                        marginRight: "-13px",
                                        // zIndex را به ترتیب معکوس قرار می‌دهیم
                                        zIndex: arr.length - i,
                                        position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                                    }}
                                ></div>
                            ))}
                        </div>
                        <div style={{ ...getStepStyle("rgba(114, 194, 234, 1)", 8), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)", gap: "20px" }}> پایتون مقدماتی یک</div>


                        {/* زانوی اول (سمت چپ) */}

                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(8, "rgba(114, 194, 234, 1)"),
                            borderLeftColor: getStatusColor(8, "rgba(114, 194, 234, 1)"),
                        }}></div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(8, "rgba(114, 194, 234, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>


                    </div>

                    {/* ردیف ۲: میانی (نارنجی) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(114, 194, 234, 1)", 9), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}> پایتون مقدماتی دو </div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(9, "rgba(114, 194, 234, 1)"),
                            borderRightColor: getStatusColor(9, "rgba(114, 194, 234, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(9, "rgba(114, 194, 234, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>

                    {/* ردیف ۳: نهایی (قرمز) */}
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(114, 194, 234, 1)", 10),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            دوره متوسطه پایتون
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(10, "rgba(114, 194, 234, 1)"),
                            borderLeftColor: getStatusColor(10, "rgba(114, 194, 234, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(10, "rgba(114, 194, 234, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(249, 193, 30, 1)", 11), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}> بازی سازی با پایتون</div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(11, "rgba(249, 193, 30, 1)"),
                            borderRightColor: getStatusColor(11, "rgba(249, 193, 30, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(11, "rgba(249, 193, 30, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(159, 208, 107, 1)", 12),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            بازی سازی با میکرو پایتون
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(12, "rgba(159, 208, 107, 1)"),
                            borderLeftColor: getStatusColor(12, "rgba(159, 208, 107, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(12, "rgba(159, 208, 107, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgb(224, 99, 109)", 13), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}> پایتون و اپلیکیشن سازی </div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(13, "rgb(224, 99, 109)"),
                            borderRightColor: getStatusColor(13, "rgb(224, 99, 109)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(13, "rgb(224, 99, 109)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(29, 46, 126, 1)", 14),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            علم داده
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(14, "rgba(29, 46, 126, 1)"),
                            borderLeftColor: getStatusColor(14, "rgba(29, 46, 126, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(14, "rgba(29, 46, 126, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(42, 131, 194, 1)", 15), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}>هوش مصنوعی یک </div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(15, "rgba(42, 131, 194, 1)"),
                            borderRightColor: getStatusColor(15, "rgba(42, 131, 194, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(15, "rgba(42, 131, 194, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(42, 131, 194, 1)", 16),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            هوش مصنوعی دو
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(16, "rgba(42, 131, 194, 1)"),
                            borderLeftColor: getStatusColor(16, "rgba(42, 131, 194, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(16, "rgba(42, 131, 194, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(42, 131, 194, 1)", 17), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}> هوش مصنوعی سه </div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(17, "rgba(42, 131, 194, 1)"),
                            borderRightColor: getStatusColor(17, "rgba(42, 131, 194, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(17, "rgba(42, 131, 194, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(159, 208, 107, 1)", 18),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 90% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            اینترنت اشیا
                        </div>
                        <div style={{ display: "flex", gap: "9px", marginLeft: "10px" }}>
                            <div style={{
                                width: "28px",
                                height: "50px",
                                marginRight: "-25px",
                                backgroundColor: "transparent",
                                zIndex: "10",
                                clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"
                            }}></div>
                            {["rgb(159, 208, 107)", "rgba(134, 174, 92, 1)", "rgba(200, 239, 159, 1)", "rgba(228, 251, 204, 1)"].map((op, i, arr) => (
                                <div
                                    key={i}
                                    style={{
                                        width: "20px",
                                        height: "50px",
                                        backgroundColor: op,
                                        clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                        marginRight: "-13px",
                                        // zIndex را به ترتیب معکوس قرار می‌دهیم
                                        zIndex: arr.length - i,
                                        position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                                    }}
                                ></div>
                            ))}
                        </div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>



                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "260px", position: "relative", marginRight: "0px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}




                    </div>

                </div>


            </Tab>
            <Tab eventKey="مسیر بعد از پایتون" title="مسیر بعد از پایتون" >
                <div className='d-lg-flex d-none' style={{ padding: "100px", paddingTop: "20px", display: "flex", flexDirection: "column-reverse", alignItems: "center", gap: "40px", direction: "ltr" }}>

                    {/* ردیف ۱: از راست به چپ (شروع با HTML/CSS) */}
                    <div style={{ display: "flex", flexDirection: "row-reverse", alignItems: "center", width: "800px", position: "relative" }}>
                        {/* فلش‌های شروع گرادینتی */}
                        <div style={{ display: "flex", marginLeft: "-0px" }}>
                            {["rgba(255, 201, 187, 1)", "rgba(240, 166, 147, 1)", "rgba(230, 129, 102, 1)", "rgba(233, 114, 83, 1)", "rgba(228, 77, 38, 1)"].map((c, i, arr) => (
                                <div key={i} style={{
                                    width: "20px", height: "50px", backgroundColor: c,
                                    clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                    marginRight: "-8px", zIndex: arr.length + i, position: "relative"
                                }} />
                            ))}
                        </div>
                        {/* آیتم با گرادینت */}
                        <div style={{
                            ...getStepStyle("transparent", 20),
                            backgroundImage: getStatusColor(20, "linear-gradient(to left, #f16529, #29abe2)"),
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)",
                            flex: 1
                        }}>HTML / CSS</div>
                        <div style={{ ...getStepStyle("#dbb026", 21), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)" }}>جاوا اسکریپت مقدماتی</div>
                        <div style={{ ...getStepStyle("#dbb026", 22), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)" }}>جاوا اسکریپت پیشرفته</div>

                        {/* زانوی اول: اتصال به بالا (سمت چپ) */}
                        <div style={{
                            borderColor: getStatusColor(22, "#dbb026"),
                            position: "absolute", left: "-60px", top: "-90px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(25, "#dbb026"),
                            borderLeftColor: getStatusColor(25, "#dbb026"),
                        }}></div><div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(25, "#092e20"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "2px", top: "-180px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(22, "#dbb026"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "-180px",
                                position: "absolute",
                                left: "10px",


                            }}
                        ></div>
                    </div>

                    {/* ردیف ۲: از چپ به راست (Django و React) */}
                    <div style={{ display: "flex", flexDirection: "row-reverse", alignItems: "center", width: "800px", position: "relative" }}>
                        <div style={{ ...getStepStyle("#092e20", 25), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)" }}>Django</div>
                        <div style={{ ...getStepStyle("#8cc152", 24), clipPath: "polygon(92% 0%, 100% 50%, 92% 100%, 0% 100%, 8% 50%, 0% 0%)" }}>ری‌اکت پیشرفته</div>
                        <div style={{ ...getStepStyle("#8cc152", 23), clipPath: "polygon(92% 0%, 100% 50%, 92% 100%, 0% 100%, 8% 50%, 0% 0%)", marginLeft: "19px" }}>ری‌اکت مقدماتی</div>

                        {/* زانوی دوم: اتصال به بالا (سمت راست) */}
                        <div style={{

                            position: "absolute", right: "-81px", top: "-90px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(25, "#092e20"),
                            borderRightColor: getStatusColor(25, "#092e20"),
                        }}></div>
                    </div>

                    {/* ردیف ۳: ردیف آخر به سمت پایان */}
                    <div style={{ display: "flex", flexDirection: "row", height: "50px", alignItems: "center", width: "800px", position: "relative" }}>
                        {/* دایره پایان مسیر */}
                        <div style={{
                            width: "90px", height: "90px", backgroundColor: "#7e76f6", borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center", color: "white",
                            border: "4px solid white", boxShadow: "0 0 15px rgba(126, 118, 246, 0.5)", zIndex: 5, marginLeft: "-45px"
                        }}>
                            پایان مسیر
                        </div>

                        <div style={{ ...getStepStyle("#7e76f6", 27), clipPath: "polygon(100% 0%, 95% 50%, 100% 100%, 0% 100%, 0% 0%)", marginLeft: "-8px" }}>UI / UX</div>
                        <div style={{ ...getStepStyle("#1a237e", 26), clipPath: "polygon(100% 0%, 95% 50%, 100% 100%, 5% 100%, 0% 50%, 5% 0%)", marginRight: "-4px" }}>Data base</div>
                    </div>
                </div>
                <div className='d-flex d-lg-none' style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "40px",

                    padding: "40px 20px",
                }}>

                    {/* ردیف ۱: شروع مسیر (پایین) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px", marginTop: "-20px", height: "50px" }}>
                        <div style={{ display: "flex", gap: "4px", marginLeft: "10px" }}>
                            <div style={{
                                width: "28px",
                                height: "50px",
                                marginRight: "-25px",
                                backgroundColor: "transparent",
                                zIndex: "10",
                                clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"
                            }}></div>
                            {["rgba(228, 77, 38, 1)", "rgba(230, 129, 102, 1)", "rgba(240, 166, 147, 1)", "rgba(255, 201, 187, 1)"].map((op, i, arr) => (
                                <div
                                    key={i}
                                    style={{
                                        width: "20px",
                                        height: "50px",
                                        backgroundColor: op,
                                        clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                        marginRight: "-13px",
                                        // zIndex را به ترتیب معکوس قرار می‌دهیم
                                        zIndex: arr.length - i,
                                        position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                                    }}
                                ></div>
                            ))}
                        </div>
                        <div style={{ ...getStepStyle("rgba(114, 194, 234, 1)", 20), clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)", gap: "20px", backgroundImage: getStatusColor(20, "linear-gradient(to left, #f16529, #29abe2)") }}>HTML / CSS</div>


                        {/* زانوی اول (سمت چپ) */}

                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(20, "#29abe2"),
                            borderLeftColor: getStatusColor(20, "#29abe2"),
                        }}></div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(20, "#29abe2"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "relative" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>


                    </div>

                    {/* ردیف ۲: میانی (نارنجی) */}
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(218, 185, 45, 1)", 21), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}>   جاوا اسکریپت مقدماتی </div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(21, "rgba(218, 185, 45, 1)"),
                            borderRightColor: getStatusColor(21, "rgba(218, 185, 45, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(21, "rgba(218, 185, 45, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>

                    {/* ردیف ۳: نهایی (قرمز) */}
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(218, 185, 45, 1)", 22),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            جاوا اسکریپت پیشرفته
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(22, "rgba(218, 185, 45, 1)"),
                            borderLeftColor: getStatusColor(22, "rgba(218, 185, 45, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(22, "rgba(218, 185, 45, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(136, 183, 99, 1)", 23), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}>  ری‌اکت مقدماتی </div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(23, "rgba(136, 183, 99, 1)"),
                            borderRightColor: getStatusColor(23, "rgba(136, 183, 99, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(23, "rgba(136, 183, 99, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(136, 183, 99, 1)", 24),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            ری‌اکت پیشرفته
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(24, "rgba(136, 183, 99, 1)"),
                            borderLeftColor: getStatusColor(24, "rgba(136, 183, 99, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(24, "rgba(136, 183, 99, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(1, 55, 43, 1)", 25), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}> Django</div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(25, "rgba(1, 55, 43, 1)"),
                            borderRightColor: getStatusColor(25, "rgba(1, 55, 43, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(25, "rgba(1, 55, 43, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute"
                            }}
                        ></div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", width: "230px", position: "relative", marginRight: "20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}


                        <div style={{
                            ...getStepStyle("rgba(29, 46, 126, 1)", 26),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 0% 100%, 0% 0%)"
                        }}>
                            Data base
                        </div>
                        <div style={{
                            position: "absolute", left: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(-45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderRightColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(26, "rgba(29, 46, 126, 1)"),
                            borderLeftColor: getStatusColor(26, "rgba(29, 46, 126, 1)"),
                        }}></div>  <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(26, "rgba(29, 46, 126, 1)"),
                                clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                marginRight: "-20px",
                                marginTop: "180px",
                                position: "absolute",
                                left: "0",

                            }}
                        ></div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", position: "relative", width: "250px" }}>
                        <div style={{ ...getStepStyle("rgba(133, 118, 247, 1)", 27), clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 8% 50%, 0% 0%)", gap: "20px", marginLeft: "8px" }}> UI / UX</div>

                        {/* زانوی دوم (سمت راست) */}
                        <div style={{
                            position: "absolute", right: "-70px", top: "0px", width: "140px", height: "140px",

                            transform: "rotate(45deg)", zIndex: 0,
                            borderWidth: "50px", borderStyle: "solid", borderRadius: "50%", borderLeftColor: "transparent", borderBottomColor: "transparent",
                            borderTopColor: getStatusColor(27, "rgba(133, 118, 247, 1)"),
                            borderRightColor: getStatusColor(27, "rgba(133, 118, 247, 1)"),
                        }}>

                        </div>
                        <div

                            style={{
                                width: "20px",
                                height: "50px",
                                backgroundColor: getStatusColor(27, "rgba(133, 118, 247, 1)"),
                                clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
                                marginRight: "-13px",
                                right: "13px", top: "90px",
                                position: "absolute" // برای اینکه z-index کار کند باید position تعریف شود
                            }}
                        ></div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", width: "260px", position: "relative", marginRight: "0px", marginTop: "-20px" }}>
                        {/* فلش‌های انتهای مسیر (سمت چپ) */}

                        <div style={{
                            ...getStepStyle("rgba(133, 118, 247, 1)"),
                            flex: 1,
                            clipPath: "polygon(100% 0%, 92% 50%, 100% 100%, 8% 100%, 0% 50%, 8% 0%)",
                            zIndex: "20",
                            padding: "0"

                        }}>

                        </div>


                        <div style={{
                            width: "90px", height: "90px", backgroundColor: "rgba(133, 118, 247, 1)", borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center", color: "white",
                            border: "4px solid white", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", zIndex: 100, marginRight: "-20px"
                        }}>
                            پایان مسیر
                        </div>

                    </div>

                </div>

            </Tab>
        </Tabs >
    );
}

export default Roadmap;